import {call, put, race, select, delay} from 'redux-saga/effects';
import {tripica} from '../../../api';
import I18n from '../../../lib/i18n';
import {isLoggedInSelector} from '../../Authentication';
import {createDeviceId} from '../../Authentication/sagas';
import {setError} from '../../LoadingStatus';
import {loginSelector} from '../Login';
import {orderStateSelector, orderUuidSelector, setOrderUuid} from '../Order';
import {orderStatusCheck} from './polling';

export function* register(): Generator<*, *, *> {
  const {
    email,
    password,
    validationCode,
    optionExternalCommercial,
    optionInternalCommercial,
  } = yield select(loginSelector);
  const uuid = yield select(orderUuidSelector);
  const deviceId = yield call(createDeviceId);

  if (!deviceId) {
    throw new Error('[Batch] Deivce id could not be generated during register');
  }

  const now = Date.now();
  var login = {
    email: email,
    password: password,
  };

  if (optionInternalCommercial) {
    login['customerPreference.characteristics.optionInternalCommercial'] = now;
  }

  if (optionExternalCommercial) {
    login['customerPreference.characteristics.optionExternalCommercial'] = now;
  }

  const response = yield call(
    [tripica, 'register'],
    login,
    {nationality: 'FRA'},
    uuid,
    email,
    {
      validationCode: validationCode ? validationCode : '',
    },
  );
  yield put(setOrderUuid(response.uuid));

  if (response && response.status === 'VALIDATED') {
    const {timeout} = yield race({
      orderStatusCheck: call(orderStatusCheck),
      timeout: delay(35000),
    });

    const orderState: string = yield select(orderStateSelector);
    const isLoggedIn = yield select(isLoggedInSelector);
    
    if (timeout && !isLoggedIn) {
      yield put(setError('redirectAfterRegister', {type: 'LOGIN_TIMEOUT'}));
    }
    
    switch (orderState) {
      case 'COMPLETED':
        break;
      case 'FAILED':
      case undefined:
      case null:
        yield put(
          setError('redirectAfterRegister', {
            type: 'FAILED',
            title: I18n.t('error.orderFailed'),
          }),
        );
        break;
      case 'IN_PROGRESS':
      default:
        yield put(
          setError('redirectAfterRegister', {
            type: 'IN_PROGRESS',
            title: I18n.t('SignUp.Congrats.orderInProgress'),
          }),
        );
        break;
    }
  }
  return response;
}
